import { CAMPAIGN_ACTION_FIELD, UNSUBSCRIBED_DATE_FIELD } from '../../Contacts/config/table-headers';
import { DatetimeQueryBuilder } from '@/Core/utilities/filter-query-builders/DatetimeQueryBuilder';

const NOT_SUPPORTED_OPERATORS_NEXT_CAMPAIGN_ACTION = {
    [CAMPAIGN_ACTION_FIELD]: [
        DatetimeQueryBuilder.Operators['MORE_THAN_X_DAYS_AGO'].name,
        DatetimeQueryBuilder.Operators['WITHIN_LAST_X_DAYS'].name,
        DatetimeQueryBuilder.Operators['YESTERDAY'].name
    ],
    [UNSUBSCRIBED_DATE_FIELD]: [
        DatetimeQueryBuilder.Operators['TOMORROW'].name,
        DatetimeQueryBuilder.Operators['WITHIN_NEXT_X_DAYS'].name,
        DatetimeQueryBuilder.Operators['MORE_THAN_X_DAYS_FROM_NOW'].name
    ]
};

export default {
    ...NOT_SUPPORTED_OPERATORS_NEXT_CAMPAIGN_ACTION
};
